<template>
  <div style="box-shadow: 0 0 0 0 !important" class="adminGraph">
    <v-row justify="center" class="mt-5 graphContent" style="margin: 0px">
      <DailyReportFilterSimple @handleFilter="handleFilter" @exportsToExcel="exportsToExcel"/>
    </v-row>
    <div v-if="!getDataDone">
      <SliderGroup
          :options="this.options"
          @removeRow="removeRow($event)"
          style="margin-bottom: 30px"
      />
      <table-component
          itemKey="id"
          :headers="tableHeaders"
          :formBody="body"
          :pagination="this.$store.state.pagination"
          :limit="$store.state.counterOfShow"
          :items="tableData"
          :loading="loading"
          v-model="page"
      >
      </table-component>
    </div>
    <div v-else class="loader">
      <img src="../../../assets/Comp-2.gif" />
    </div>
  </div>
</template>
<style>
.bg-primary {
  background-color: rgb(63, 14, 64) !important;
  color: #fff !important;
  border: 1px solid #ddd !important;
}
.bg-primary * {
  color: #fff !important;
}

.v-data-table__wrapper > table > thead > tr > th.dimensions {
  text-align: center;
}

.v-data-table-header th.height,
.v-data-table-header th.base,
.v-data-table-header th.volume {
  display: none;
}

.v-data-table tr td.dimensions {
  text-align: center;
}

.v-data-table tr td.height,
.v-data-table tr td.base,
.v-data-table tr td.volume {
  display: none;
}
</style>
<script>
import DailyReportFilterSimple from "./DailyReportFilterSimple.vue";
import SliderGroup from "@/components/Charts/SliderGroup";

import Axios from "axios";
import * as XLSX from "xlsx";

export default {
  components: {
    DailyReportFilterSimple,
    SliderGroup,
  },

  data() {
    const yesterdayDate = new Date();
    yesterdayDate.setDate(yesterdayDate.getDate() - 1); // Subtract one day

    return {
      chartData: [],
      tableData: [],
      options: [],
      showArray: [],
      filterObj: {},
      body: {},
      page: 1,
      getDataDone: false,
      loading: false,
      today:
          new Date().getFullYear() +
          "-" +
          ("0" + (new Date().getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + new Date().getDate()).slice(-2),
      yesterday:
          yesterdayDate.getFullYear() +
          "-" +
          ("0" + (yesterdayDate.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + yesterdayDate.getDate()).slice(-2),
      tableHeaders: [
        { text: "موظف خدمه العملاء", value: "موظف خدمه العملاء", align: "center" , width: "170px"},
        // { text: "المستقبلة", value: "المستقبلة", align: "center" , tooltip: "الطلبات التي استقبلها الأستشاري سواء كانت تلقائي حسب الدور أو محولة إليه من مدير النظام أو طلب تم سحبه من إستشاري آخر " },
        { text: "الطلبات الجديدة", value: "الطلبات الجديدة", align: "center" , tooltip: "الطلبات الجديدة"},
        { text: "% الطلبات الجديدة", value: "% الطلبات الجديدة", align: "center"  , tooltip: "نسبة الطلبات الجديدة"},
        { text: "المتابعه", value: "المتابعه", align: "center" , tooltip: "الطلبات التي تم الأجابة على هل بالامكان البيع للعميل؟ بنعم ومازلت بنعم  " },
        { text: "%المتابعه", value: "%المتابعه", align: "center"  , tooltip: "نسبة المتابعة من الطلبات المستقبلة"},
        // { text: "%المستقبلة", value: "%المستقبلة", align: "center"  , tooltip: "نسبة المستقبلة"},
        { text: "المرسلة لسلة المبيعات", value: "المرسلة لسلة المبيعات", align: "center"  , tooltip: "الطلبات التى تم رفعها لمدير المبيعات من قبل الاستشاري"},
        { text: "%المرسلة لسلة المبيعات", value: "%المرسلة لسلة المبيعات", align: "center"  , tooltip: "نسبة المرسلة لسلة المبيعات"},
      ],
    };
  },

  watch: {
    page(val) {
      this.getData(val, "loading");
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval !== oldvalue && !this.$store.state.admin_search_active) {
          this.getData(this.page,'loading');
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },

  },

  methods: {
    removeRow(headerValue) {
      let findIndex = this.tableHeaders.findIndex((item) => item.text === headerValue);

      if (findIndex !== -1) {
        this.tableHeaders.splice(findIndex, 1);
        this.showArray.splice(findIndex, 0, {
          id: findIndex,
          value: headerValue,
        });
      } else {
        let foundInsertedItem = this.options.findIndex((item) => item === headerValue);

        this.showArray.sort((a, b) => a.id - b.id);
        this.showArray.map((res, index) => {
          if (res.value === headerValue) {
            this.tableHeaders.splice(foundInsertedItem - (index - 1), 0, {
              text: headerValue,
              value: headerValue,
            });
            this.showArray.splice(index, 1);
          }
        });
      }
    },
    exportsToExcel() {
      const worksheet = XLSX.utils.json_to_sheet(this.tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Filtered Data");
      XLSX.writeFile(workbook, "filtered_data.xlsx");
    },
    handleFilter(val) {
      val = val || {};
      this.filterObj = val;
      this.body = new FormData();

      if (val?.startDate) {
        this.body.append("start_date", val.startDate);
      } else {
        // default
        this.body.append("start_date", this.yesterday);
      }

      if (val?.endDate) {
        this.body.delete("end_date");
        this.body.append("end_date", val.endDate);
      } else {
        // default
        this.body.append("end_date", this.today);
      }
      // Normalize status -> backend expects 1 (active) or 0 (archived)
      if (val.status == undefined || val.status == "") {
        val.status = "استشاري قائم"; // default
      }
      const statusValue = val.status === "استشاري مؤرشف" ? 0 : 1;
      this.body.append("status", statusValue);

      if (val.range) {
        this.body.append("range", val.range);
      }

      if (val.managerId?.length) {
        const managerProperties = {};

        val.managerId.forEach((item, index) => {
          this.body.append([`manager_id[${index}]`], item.id);
        });
      }

      if (val.agentId?.length) {
        const managerProperties = {};

        val.agentId.forEach((item, index) => {
          this.body.append([`adviser_id[${index}]`], item.id);
        });
      }

      if (val.dayNumber) {
        this.body.append("range", val.dayNumber);
      }
      this.getData(1, "getDataDone");
    },

    getData(page, loader) {
      if (loader === "getDataDone") {
        this.getDataDone = true;
      } else if (loader === "loading") {
        this.loading = true;
      }
      this.options = [];
      this.tableData = [];
      let url = `${this.$store.state.url}/employee/admin/getProductivity?is_customer_service=1&page=${page}&per_page=${this.$store.state.counterOfShow}`;
      Axios.post(url, this.body, { headers: this.request_headers() }).then((res) => {
        this.setTableData(res.data.payload.data);
        this.setOptions();
        this.chartData = res.data.payload;
        this.$store.state.pagination = {
          limit: 3,
          count: res.data.payload.total_agents,
        };
        this.loading = false;
        this.getDataDone = false;
      });
    },

    setOptions() {
      this.options = [];
      // Only add the specific columns to the tabs (excluding موظف خدمه العملاء)
      this.tableHeaders.map((item, index) => {
        if (item.text !== "موظف خدمه العملاء" && item.text !== "التحكم") {
          this.options.push(item.text);
        }
      });
    },

    setTableData(data) {
      data.map((res) => {
        // Calculate percentage of received (assuming it's 100% as base, or use API data if available)
        const receivedPercentage = res.total_received_request?.percentage || "100%";
        // Get new requests data from API (adjust field names based on actual API response)
        const newRequestsCount = res.new_requests?.count || res.new_request_count || 0;
        const newRequestsPercentage = res.new_requests?.percentage || res.new_request_percentage || "0%";
        
        this.tableData.push({
          "موظف خدمه العملاء": res.name,
          "المستقبلة": res.total_received_request?.count,
          "الطلبات الجديدة": res.total_received_request?.count,
          "% الطلبات الجديدة": res.total_received_request?.percentage,
          "المتابعه": res.possible_to_sell_to_customer_count?.count,
          "%المتابعه": res.followed_basket_possible_to_sell?.percentage,
          "%المستقبلة": receivedPercentage,
          "المرسلة لسلة المبيعات": res.total_completed_cs_request?.count,
          "%المرسلة لسلة المبيعات": res.total_completed_cs_request?.percentage,
        });
      });
    },
  },

  created() {
    this.handleFilter({});
    this.getData(1, "getDataDone");
    this.$store.state.pagination = {};
  },
};
</script>
